/**
 * Tracks whether the user is navigating by keyboard, as `[data-kbd-nav]` on
 * `<html>`. The `kbd-nav:` Tailwind variant (see index.css) keys focus rings
 * off it, so rings appear only after an explicit Tab and vanish on the next
 * pointer press.
 *
 * This exists because `:focus-visible` alone can't express that rule for text
 * fields: browsers treat any focused text input as focus-visible — click, tap,
 * or autofocus included — since typing is keyboard interaction. Buttons get the
 * ring on focus restoration (e.g. a closing dialog) for similar reasons.
 */
export function installKeyboardModalityTracking(doc: Document = document) {
  doc.addEventListener(
    "keydown",
    (e) => {
      if (e.key === "Tab") doc.documentElement.setAttribute("data-kbd-nav", "");
    },
    { capture: true },
  );
  doc.addEventListener("pointerdown", () => doc.documentElement.removeAttribute("data-kbd-nav"), {
    capture: true,
  });
}
